import { styled } from '@mui/material/styles';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';
import { getColumnStyle } from 'utils';

const shrinkColumnStyle = { width: 0 };
const columnStyle120 = { width: 0 };

export const DatagridStyled = styled(DatagridWithStickyActions)({
  '& .column-provider': shrinkColumnStyle,
  '& td.column-provider': { whiteSpace: 'nowrap' },
  '& .column-comment': shrinkColumnStyle,
  '& td.column-comment .MuiBox-root > .MuiTypography-root': {
    width: 'max-content',
    maxWidth: '230px',
  },
  '& .column-credentials': getColumnStyle(158),
  '& td.column-credentials': { whiteSpace: 'nowrap' },
  '& .column-createdAt': columnStyle120,
  '& .column-updatedAt': columnStyle120,
});
